import { useState } from 'react';
import { WebshopWidgetListItemDto } from 'src/models/WebshopWidget';
import { getWebshopWidgets } from 'src/services/getWebshopWidgets';
import useAsyncEffect from 'use-async-effect';

const useWebshopWidgets = () => {
  const [webshopWidgets, setWebshopWidgets] = useState<WebshopWidgetListItemDto[]>([]);

  useAsyncEffect(async () => {
    const webshopWidgetData = await getWebshopWidgets();
    setWebshopWidgets(webshopWidgetData);
  }, []);

  return { webshopWidgets };
};

export default useWebshopWidgets;
